import storageKey from "@/constant/storage_key";

export default {
    set: function(key:storageKey, value:string) {
        localStorage.setItem(key, JSON.stringify(value))
    },

    get: function(key:storageKey) {
        const val = localStorage.getItem(key)
        return val ? JSON.parse(val) : null;
    },

    remove: function(key:storageKey) {
        localStorage.removeItem(key);
    }
  }